import React from "react";
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import { DatosTransporte } from "../../../services/carritoServicios";
import { contienenLoMismo } from "../../../utils/arrayUtils";
import { stringADate } from "../../../utils/dateUtils";
import { InfoRow } from "../../organisms/InfoRow";
import { StyledCalendar } from "./organisms/StyledCalendar";
import { IconContainer } from "./organisms/IconContainer";

export const SeccionTransporte = ({
  datos,
  fechasReserva,
}: {
  datos: DatosTransporte;
  fechasReserva: string[];
}) => {
  return (
    <section className="mb-4">
      <h5 className="mb-2" style={{ fontWeight: 500 }}>
        <IconContainer>
          <AirportShuttleIcon />
        </IconContainer>
        Datos de transporte
      </h5>
      <FechasTransporte
        fechasTransporte={datos.fechas}
        fechasReserva={fechasReserva}
      />

      <InfoRow
        label="Sector de transporte"
        value={datos.sector?.nombre || ""}
      />
      <InfoRow label="Dirección de transporte" value={datos.direccion || ""} />
      <InfoRow label="Ida" value={(!!datos.datosIda || !!datos.datosIdaVuelta) ? "Si" : "No"} />
      <InfoRow label="Vuelta" value={(!!datos.datosVuelta || !!datos.datosIdaVuelta) ? "Si" : "No"} />
    </section>
  );
};

const FechasTransporte = ({
  fechasTransporte,
  fechasReserva,
}: {
  fechasTransporte: string[];
  fechasReserva: string[];
}) => {
  if (fechasTransporte.length === 0) return <></>;
  if (contienenLoMismo(fechasTransporte, fechasReserva)) {
    return <InfoRow label="Fechas de transporte" value={"Todas"} />;
  }
  const fechasTransporteDate = fechasTransporte.map((f) => stringADate(f));
  return (
    <div className="mb-2">
      <label className="mb-2" style={{ fontWeight: 500 }}>
        Fechas de transporte:
      </label>
      <StyledCalendar
        preSelectedDates={fechasTransporteDate}
        disableAll={true}
      />
    </div>
  );
};
